module.exports = __webpack_public_path__ + "img/icon-user.874c6b33.svg";